import { PropsWithChildren } from 'react';
import { useSelector } from 'react-redux';
import LoaderOverlay from 'components/PageLayout/LoaderOverlay';
import { selectIsGloballyLoading } from 'handlers/globalLoadingSlice';

const GlobalLoaderWrapper = ({ children }: PropsWithChildren) => {
  const isGloballyLoading = useSelector(selectIsGloballyLoading);

  return (
    <>
      {isGloballyLoading && <LoaderOverlay fullscreen />}
      <div style={{ display: isGloballyLoading ? 'none' : 'block' }}>
        {children}
      </div>
    </>
  );
};

export default GlobalLoaderWrapper;
